export default {"src":"/_next/static/media/reports-active-icon.bff543c5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};